import HomeIndex from '@/controllers/home-index.js'
import CONFIG from '@/assets/js/config.custom.js'

export default {
  extends: HomeIndex,
  data() {
    return {
      role: CONFIG.ROLE.ID,
    }
  },

  computed: {
    isHr() {
      const user = this.$store.state.user;
      if (!user) return false;

      return user.role === this.role.HR_OPERATOR;
    },

    isSuperAdmin() {
      const user = this.$store.state.user;
      if (!user) return false;

      return user.role === this.role.SUPER_ADMIN;
    },
  },

  mounted() {
    this.isLoading = true;
    this.getNoticecount();
    this.getTotalTeacherCount();
    this.getTotalStudentCount();
    this.getLatestStudentList();
    if (!this.isTeacher || this.isSuperAdmin) {
      this.getPaymentData();
      this.getTransactionInfo();
    }

    if (this.isHr || this.isSuperAdmin) {
      this.fetchLatestEmployeeList();
      this.getTotalEmployeeCount();
      this.getTotalDriverCount();
      this.getTotalFerryCount();
    }
    this.$store.state.user.role == CONFIG.ROLE.ID.STAFF ? this.isStaff = true : this.isStaff = false;
    this.$store.state.user.role == CONFIG.ROLE.ID.ACCOUNTANT ? this.isAccountant = true : this.isAccountant = false;
  },
}
